import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

import { get, put } from '../utils/networkUtils';

const TOAST_ID = 1;

export default function LoginToastPage() {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [type, setType] = useState('info');
  const [heading, setHeading] = useState('');
  const [body, setBody] = useState('');
  const [colorHex, setColorHex] = useState('#20D77F');
  const [location, setLocation] = useState('login');

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const data = await get('/settings/login-toast');

        if (data) {
          setIsActive(Boolean(data.isActive));
          setType(data.type || 'info');
          setHeading(data.heading || '');
          setBody(data.body || '');
          setColorHex(data.colorHex || '#20D77F');
          setLocation(data.location || 'login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSettings().catch(console.error);
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await put(`/admin/settings/login-toast/${TOAST_ID}`, {
        isActive,
        type,
        heading,
        body,
        colorHex,
        location,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> Login Toast </title>
      </Helmet>

      <Container maxWidth="sm">
        <Typography variant="h4" sx={{ mb: 3 }}>
          Login Toast Configuration
        </Typography>

        <Card sx={{ p: 3 }}>
          {loading ? (
            <Typography variant="body1">Loading...</Typography>
          ) : (
            <Stack spacing={3}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="subtitle1">Enable Toast</Typography>
                <Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
              </Box>

              <FormControl fullWidth>
                <InputLabel id="toast-type-label">Type</InputLabel>
                <Select
                  labelId="toast-type-label"
                  value={type}
                  label="Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value="info">Info</MenuItem>
                  <MenuItem value="success">Success</MenuItem>
                  <MenuItem value="warning">Warning</MenuItem>
                  <MenuItem value="error">Error</MenuItem>
                  <MenuItem value="system">System</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="toast-location-label">Location</InputLabel>
                <Select
                  labelId="toast-location-label"
                  value={location}
                  label="Location"
                  onChange={(e) => setLocation(e.target.value)}
                >
                  <MenuItem value="login">Login</MenuItem>
                  <MenuItem value="lobby">Lobby</MenuItem>
                  <MenuItem value="both">Both</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Heading"
                fullWidth
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
              />

              <TextField
                label="Body"
                fullWidth
                multiline
                minRows={3}
                value={body}
                onChange={(e) => setBody(e.target.value)}
              />

              <TextField
                label="Hex Color (background)"
                fullWidth
                value={colorHex}
                onChange={(e) => setColorHex(e.target.value)}
                helperText="Example: #20D77F"
              />

              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleSave} disabled={saving}>
                  {saving ? 'Saving...' : 'Save'}
                </Button>
              </Box>
            </Stack>
          )}
        </Card>
      </Container>
    </>
  );
}


